export const DASHBOARD_INFO = "DASHBOARD_INFO";
